import React from "react";
import { ListPartner } from "components";
import { getTitleDecoration } from "utils/common";

const ModalUpdateSuccess = ({ entry, partnership, closeFn, open = false }) => {
  return (
    <>
      {open && (
        <div className="modal active">
          <div className="modal-body">
            <div className="title text-black mt-2">変更を反映しました</div>

            <div className="box p-2 p-md-3 my-3 text-start">
              <div>
                <div
                  className="d-block d-md-inline-block mb-1 mb-md-0"
                  dangerouslySetInnerHTML={{
                    __html: getTitleDecoration(
                      entry?.title_decoration?.title_decoration_content
                    ),
                  }}
                ></div>

                <span className="align-middle fs-14">{entry?.title_login}</span>
              </div>
              <ListPartner entry={entry} list={partnership} type={2} />
            </div>

            <div className="my-3 text-center">
              <div onClick={closeFn} className="btn-custom mt-2">
                閉じる
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalUpdateSuccess;
